import { Injectable } from '@angular/core';
import { WancomHttpService } from '../wancom-http/wancom-http.service';
import { environment } from '../../../environments/environment';
import { HasId } from '../../helpers/crud/edit/HasId';

@Injectable({
    providedIn: 'root',
})
export class OrganizationService {
    //#region Variables

    private url: string;

    //#endregion Variables

    //MARK: Constructor
    constructor(private http$: WancomHttpService) {
        this.url = 'organization';
    }

    searchExistantSIRET(siret: string) {
        return this.http$.post<OutputSearchSiret>(
            `${this.url}/searchExistantSIRET`,
            { siret: siret },
            environment.apiBaseStore
        );
    }
}

export interface OutputSearchSiret {
    siret: string;
    orgaName: string;
    commercialInfos: ExistingSiretContact;
}

export interface ExistingSiretContact {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}


export class OrganizationType implements HasId {
    id: number;
    name: string;
}
